module.exports = __webpack_public_path__ + "img/抄表查询.f5d6d2e4.jpg";